module.exports = __webpack_public_path__ + "static/media/Galano_Grotesque_Medium.08e00296.otf";